export default {
  LINK_ID: 'renewalLinkId',
  SUPPORT_BROWSER_LANG: [
    'zh-cn', // 中文
    'zh-tw', // 繁体中文
    'en', // 英文
    'fr', // 法语
    'es', // 西班牙语
    'de', // 德语
    'it', // 意大利语
    'pt', // 葡萄牙语
    'ru', // 俄语
    'pl', // 波兰语
    'nl', // 荷兰语
    'sv', // 瑞典语
    'ja', // 日语
    'ko', // 韩语
    'vi', // 越南语
    'th', // 泰语
    'km', // 柬埔寨语/高棉语
    'tr', // 土耳其语
    'ar', // 阿拉伯语
    'he', // 希伯来语
    'fa', // 波斯语
  ],

  BROWSER_LANG_TO_CLOUD_LANG_RULE: {
    'zh-cn': 'cn',
    'zh-tw': 'tw',
    sv: 'se',
    ja: 'jp',
    ko: 'kr',
    vi: 'vn',
    km: 'kh',
    he: 'il',
  },

  ERROR_CODE: [704001, 606003, 10005003, 606004, 606005],
};
